import React from "react";
import { Table } from "antd";
import "./RegistrationTotalsTable.css";

function fmt(val) {
  return `$${parseFloat(val || 0).toFixed(2)}`;
}

const RegistrationTotalsTable = ({ data, isBusy, onDetail, summary }) => {
  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (text) => (text === "registration" ? "Registration" : "Program"),
      sorter: (a, b) => a.type.localeCompare(b.type),
      defaultSortOrder: "ascend",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      align: "right",
      sorter: (a, b) => a.count - b.count,
      render: (text) => text || 0,
    },
    {
      title: "Revenue",
      dataIndex: "revenue",
      key: "revenue",
      align: "right",
      sorter: (a, b) => parseFloat(a.revenue || 0) - parseFloat(b.revenue || 0),
      render: (text) => fmt(text),
    },
    {
      title: "Last Timestamp",
      dataIndex: "last_timestamp",
      key: "last_timestamp",
      sorter: (a, b) => {
        if (!a.last_timestamp) return 1;
        if (!b.last_timestamp) return -1;
        return new Date(a.last_timestamp) - new Date(b.last_timestamp);
      },
      render: (text) => text || "N/A",
    },
  ];

  return (
    <div className="registration-totals-table">
      {summary && (
        <div className="reg-totals-summary">
          <div className="reg-totals-summary-item">
            <span className="reg-totals-summary-label">Registration Revenue</span>
            <span className="reg-totals-summary-value">{fmt(summary.total_revenue)}</span>
          </div>
          <div className="reg-totals-summary-item">
            <span className="reg-totals-summary-label">Conv. Fees</span>
            <span className="reg-totals-summary-value fee">{fmt(summary.total_fees)}</span>
          </div>
          <div className="reg-totals-summary-item">
            <span className="reg-totals-summary-label">Refunds</span>
            <span className="reg-totals-summary-value refund">-{fmt(summary.total_refunds)}</span>
          </div>
          <div className="reg-totals-summary-item net">
            <span className="reg-totals-summary-label">Net</span>
            <span className="reg-totals-summary-value">{fmt(summary.net)}</span>
          </div>
        </div>
      )}
      <Table
        columns={columns}
        dataSource={data}
        loading={isBusy}
        rowKey={(record) => `${record.type}-${record.id}`}
        onRow={(record) => ({
          onClick: () => onDetail(record),
          style: { cursor: "pointer" },
        })}
        pagination={{
          pageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ["20", "50", "100", "200"],
          showTotal: (total) => `Total ${total} items`,
        }}
      />
    </div>
  );
};

export default RegistrationTotalsTable;
